(function() {
    'use strict';

    /**
    * blocks.exception Module
    *
    * Description handle application exceptions
    */
    angular.module('blocks.cache', [

    	 /*
         * 3rd Party modules
         */

        'angular-cache'
    ]);

})();
